import React, { useEffect } from 'react';
import { Flex, Text } from 'rebass';

import Logo from 'assets/peteLogo1.png';
import { LoginWithGoogleButton } from 'components/LoginWithGoogleButton/LoginWithGoogleButton';
import { fetchGoogleOauth2AuthorizationCode } from 'modules/auth/actions';
import { connect, useSelector } from 'react-redux';
import { Navigate } from 'react-router';
import { DEFAULT_LOGIN_PATH } from 'routing/routePaths';
import { GlobalState } from 'reducers';
import { getIsAuthenticated } from 'selectors/auth/getIsAuthenticated';
import { DevLoginButton } from 'components/DevLoginButton/DevLoginButton';
import { getIsDeveloperLoginEnabled } from 'selectors/features/getIsDeveloperLoginEnabled';
import { getGoogleOauth2Status } from 'selectors/auth/getFetchGoogleOauth2Satus';
import { FetchStatus } from 'types/types';
import { loadGoogleIdentityServices } from 'utils/loadGoogleIdentityServices';

type LoginGoogleComponentProps = {
  isAuthenticated: boolean;
  googleOauth2Status: FetchStatus;
  fetchGoogleAuthorizationCode: typeof fetchGoogleOauth2AuthorizationCode;
};

export const LoginGoogleComponent = ({
  isAuthenticated,
  googleOauth2Status,
  fetchGoogleAuthorizationCode,
}: LoginGoogleComponentProps) => {
  const isDeveloperLoginEnabled = useSelector(getIsDeveloperLoginEnabled);
  const hasFailed = googleOauth2Status === FetchStatus.Failure;

  useEffect(() => {
    loadGoogleIdentityServices().catch(() => {
      // The epic surfaces a user-facing error if the click happens before the
      // script resolves; nothing more to do here.
    });
  }, []);

  if (isAuthenticated) {
    return <Navigate to={DEFAULT_LOGIN_PATH} replace />;
  }

  return (
    <Flex flexDirection="column" width="100%" padding={2}>
      <Flex flex="1" justifyContent="center" alignItems="center">
        <img src={Logo} alt="PeteHealth Therapist" height={78} width={200} />
      </Flex>
      <Flex
        flex="2"
        justifyContent="center"
        alignItems="center"
        flexDirection="column">
        <LoginWithGoogleButton
          onClick={() => fetchGoogleAuthorizationCode()}
          hasError={hasFailed}
        />
        {hasFailed && (
          <Text
            textAlign="center"
            width={300}
            fontSize={14}
            lineHeight={1.6}
            mt={3}
            color="danger">
            Google authentication is not available. Please disable your ad
            blocker or check your internet connection and try again.
          </Text>
        )}
        {isDeveloperLoginEnabled && (
          <Flex marginTop={4}>
            <DevLoginButton />
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};

export const LoginGoogle = connect(
  (state: GlobalState) => ({
    isAuthenticated: getIsAuthenticated(state),
    googleOauth2Status: getGoogleOauth2Status(state),
  }),
  {
    fetchGoogleAuthorizationCode: fetchGoogleOauth2AuthorizationCode,
  },
)(LoginGoogleComponent);
